import {
  initialState,
  Actions,
  State,
  EDIT_FILE,
  EDIT_FILE_SUCCESS,
  EDIT_FILE_ERROR,
  RESET_EDIT_FILE,
} from "../../types/files/edit";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_FILE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_FILE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_FILE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_FILE:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
